export { default } from './DerogatoryEventsTable';
